import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './ResponsiveMenuStyles.css';

const menuItems = [
    { label: 'Dairy, Bread & Eggs', category: 'dairy-bread-eggs' },
    { label: 'Snacks & Munchies', category: 'snacks-munchies' },
    { label: 'Fruits & Vegetables', category: 'fruits-vegetables' },
    { label: 'Cold Drinks & Juices', category: 'cold-drinks-juices' },
    { label: 'Breakfast & Instant Food', category: 'breakfast-instant-food' },
    { label: 'Bakery & Biscuits', category: 'bakery-biscuits' },
    { label: 'Chicken, Meat & Fish', category: 'chicken-meat-fish' },
];

const ResponsiveMenu = ({ isOpen = false, onClose = () => {} }) => {
    const [isDepartmentsOpen, setIsDepartmentsOpen] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const menuRef = useRef(null);
    const dropdownRef = useRef(null);
    const navigate = useNavigate();

    const toggleDepartments = () => {
        setIsDepartmentsOpen(!isDepartmentsOpen);
    };

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleCategoryClick = (category) => {
        setIsDepartmentsOpen(false);
        navigate(`/category/${encodeURIComponent(category)}`);
        onClose(); // Close mobile menu after navigation
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsDepartmentsOpen(false);
            }
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Reset dropdowns when mobile menu closes
    useEffect(() => {
        if (!isOpen) {
            setIsDepartmentsOpen(false);
            setIsDropdownOpen(false);
        }
    }, [isOpen]);

    // Close mobile menu when clicking overlay
    const handleOverlayClick = (e) => {
        if (e.target.classList.contains('navbar') && isOpen) {
            onClose();
        }
    };

    return (
        <nav className={`navbar ${isOpen ? 'mobile-menu-open' : ''}`} onClick={handleOverlayClick}>
            <div className="navbar-container">
                {/* All Departments Dropdown */}
                <div className="departments-dropdown" ref={menuRef}>
                    <button
                        onClick={toggleDepartments}
                        className="departments-button"
                        aria-label="All Departments"
                    >
                        <i className="fa fa-th-large"></i>
                        All Departments
                        <i className={`fa fa-chevron-${isDepartmentsOpen ? 'up' : 'down'}`}></i>
                    </button>

                    {isDepartmentsOpen && (
                        <div className="departments-menu">
                            <ul className="departments-list">
                                {menuItems.map((item, index) => (
                                    <li key={index} onClick={() => handleCategoryClick(item.category)}>
                                        {item.label}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>

                {/* Navigation Links */}
                <div className="navbar-links">
                    <Link to="/" className="nav-link" onClick={onClose}>Home</Link>
                    <div className="nav-dropdown" ref={dropdownRef}>
                        <button 
                            className="nav-link dropdown-toggle"
                            onClick={toggleDropdown}
                        >
                            Dropdown Menu
                            <i className={`fa fa-chevron-${isDropdownOpen ? 'up' : 'down'}`}></i>
                        </button>
                        {isDropdownOpen && (
                            <div className="nav-dropdown-menu">
                                <Link to="#" className="dropdown-item" onClick={() => { setIsDropdownOpen(false); onClose(); }}>Dropdown Link</Link>
                                <Link to="#" className="dropdown-item" onClick={() => { setIsDropdownOpen(false); onClose(); }}>Dropdown Link</Link>
                                <Link to="#" className="dropdown-item" onClick={() => { setIsDropdownOpen(false); onClose(); }}>Dropdown Link</Link>
                                <Link to="#" className="dropdown-item" onClick={() => { setIsDropdownOpen(false); onClose(); }}>Dropdown Link</Link>
                            </div>
                        )}
                    </div>
                    <Link to="#" className="nav-link" onClick={onClose}>Mega Menu</Link>
                    <Link to="#" className="nav-link" onClick={onClose}>Dashboard</Link>
                </div>
            </div>
        </nav>
    );
};

export default ResponsiveMenu;
